// extracted by mini-css-extract-plugin
module.exports = {"table":"TripManifest_table__1eFeS","tableHead":"TripManifest_tableHead__1ElAE","textOverflow":"TripManifest_textOverflow__Ctgi-"};